import { motion } from 'framer-motion'

interface LapCounterProps {
  currentLap: number
  totalLaps: number
  className?: string
}

export function LapCounter({
  currentLap,
  totalLaps,
  className = '',
}: LapCounterProps) {
  const progress = (currentLap / totalLaps) * 100

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {/* Current Lap Display */}
      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        className="text-center"
      >
        <div className="text-sm uppercase text-gray-400 font-quicksand">
          Current Lap
        </div>
        <div className="text-5xl font-fredoka font-700 text-tropical-green">
          {currentLap}
        </div>
        <div className="text-sm text-gray-400">of {totalLaps}</div>
      </motion.div>

      {/* Progress Bar */}
      <div className="w-full h-3 bg-palm-dark rounded-full overflow-hidden border border-tropical-green border-opacity-50">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ type: 'spring', stiffness: 50, damping: 20 }}
          className="h-full bg-gradient-to-r from-tropical-green via-paradise-blue to-sunny-yellow rounded-full"
        />
      </div>

      {/* Remaining Laps */}
      <motion.div
        key={currentLap}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center text-sm text-paradise-blue font-quicksand"
      >
        {totalLaps - currentLap} laps remaining
      </motion.div>
    </div>
  )
}
